var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.931 3h-15.6a1.2 1.2 0 0 0-1.2 1.2v15.6a1.2 1.2 0 0 0 1.2 1.2h15.6a1.2 1.2 0 0 0 1.2-1.2V4.2a1.2 1.2 0 0 0-1.2-1.2Z",
    fill: "currentColor"
  })));
};
export default SvgStop;